import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgGlobe = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "#3A3247",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.476 17.809A7.95 7.95 0 0 0 15.932 13h1.978a6.01 6.01 0 0 1-4.434 4.809M10.094 13h3.813A6.03 6.03 0 0 1 12 16.462 6.02 6.02 0 0 1 10.094 13M6.09 13h1.978a7.96 7.96 0 0 0 2.456 4.809A6.01 6.01 0 0 1 6.09 13m4.434-6.809A7.95 7.95 0 0 0 8.068 11H6.09a6.01 6.01 0 0 1 4.434-4.808Zm3.383 4.81h-3.813A6.03 6.03 0 0 1 12 7.54a6.03 6.03 0 0 1 1.907 3.462ZM17.91 11h-1.978a7.95 7.95 0 0 0-2.456-4.808A6.01 6.01 0 0 1 17.91 11M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16",
  clipRule: "evenodd"
})));

export { SvgGlobe as ReactComponent };
//# sourceMappingURL=Globe.svg.js.map
